export default "__VITE_ASSET__ITFA3nW8__"